import React from 'react'
import { AppConsumer } from './'

export default Component => props => (
  <AppConsumer>
    {state => <Component app={state} {...props} />}
  </AppConsumer>
)
